import {Box, Paper, Typography, styled} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Virtuoso} from 'react-virtuoso';
import {load as loadItems} from '../actions/items.js';
import formatCount from '../util/format-count.js';
import LoadingIndicator from './loading-indicator.jsx';
import SceneListItem from './scene-list-item.jsx';

const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  overflow: 'hidden',
});

const SceneList = ({loadItems, ...props}) => {
  const formattedCount = formatCount(props.items.length, 'item');

  const renderScene = index => {
    const item = props.items[index];
    return <SceneListItem key={item.id} scene={item} />;
  };

  useEffect(() => {
    loadItems(props.activeQuad);
  }, [props.activeQuad, loadItems]);

  if (props.loading && !props.items.length) {
    return <LoadingIndicator>Loading scenes...</LoadingIndicator>;
  }

  return (
    <Wrapper>
      <Paper
        elevation={1}
        square
        sx={theme => ({
          py: 1,
          px: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...theme.applyStyles('light', {backgroundColor: 'grey.100'}),
        })}
      >
        <Typography variant="overline">Contributing scenes</Typography>
        <Typography
          variant="caption"
          data-qe="number-of-scenes"
        >{`${formattedCount} found`}</Typography>
      </Paper>

      <Box
        sx={{
          backgroundColor: 'background.paper',
          height: '100%',
        }}
      >
        <Virtuoso totalCount={props.items.length} itemContent={renderScene} />
      </Box>
    </Wrapper>
  );
};

SceneList.propTypes = {
  activeQuad: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  loadItems: PropTypes.func,
};

const mapStateToProps = ({activeQuad, items}) => ({
  activeQuad,
  items: items.items,
  loading: !!items.loading,
});

const mapDispatchProps = {
  loadItems,
};

export default connect(mapStateToProps, mapDispatchProps)(SceneList);
